import styled from 'styled-components';

const RuleValue = styled.div`
  margin-bottom: ${(props): string => props.theme.spaces.sm};
  &:last-child {
    margin-bottom: 0;
  }
`;

export { RuleValue };
